/** Read role only when a valid session exists (token + role in storage). */
export const getSessionRole = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  if (!token || role === null || role === "") return null;

  const roleNum = Number(role);
  if (Number.isNaN(roleNum)) return null;

  return roleNum;
};

export const isLoanAccountRole = (role = getSessionRole()) => Number(role) === 4;

export const isReadOnlyLoanViewer = () => isLoanAccountRole(getSessionRole());

export const isAuthenticated = () => getSessionRole() !== null;

export const logout = () => {
  localStorage.removeItem("branch");
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("logged-in");
  window.location.replace("/auth");
};
